export const DEFAULT_GAME_DATA = {
    level: 1,
    info: {
        clicks: 0
    },
    money: 0,
    countRunned: 0,
    funitems: [
        {
            id: "ink",
            name: "Tattoos",
            description: `<b> Tattoo's </b><br> How can you be a rapper <br> Without tattoo? Get one!`,
            price: 1000,
            index: 2,
            isPurchaced: false,
            rate: 2,
            image_id: 1,
        },
        {
            id: "ring",
            name: "Ring",
            description: `<b> Ring </b><br> Stand out from the crowd <br> Shiny little toy for you!`,
            price: 10000,
            index: 3,
            isPurchaced: false,
            rate: 4,
            image_id: 2,
        },
        {
            id: "kicks",
            name: "Pumped up kicks",
            description: `<b> Pumped up kicks </b><br> No need to dig the dirt now. <br> Get a real pumped kicks!`,
            price: 100000,
            index: 4,
            isPurchaced: false,
            rate: 8,
            image_id: 3,
        },
        {
            id: "dreads",
            name: "Dreads",
            description: `<b> Dreads </b><br> Its colorful, its cool! <br> You got to have it!!!`,
            price: 1000000,
            index: 5,
            isPurchaced: false,
            rate: 16,
            image_id: 4,
        },
        {
            id: "tshirt",
            name: "Gucci tee",
            description: `<b> Gucci tee </b><br> Can just go arownd flapping wings. <br> Need to look sharp!`,
            price: 10000000,
            index: 6,
            isPurchaced: false,
            rate: 32,
            image_id: 5,
        },
        {
            id: "shades",
            name: "Shades",
            description: `<b> Shades </b><br> You need shades <br>  when you in spotlights!`,
            price: 50000000,
            index: 7,
            isPurchaced: false,
            rate: 96,
            image_id: 6,
        },
        {
            id: "chain",
            name: "Chain",
            description: `<b> Chain </b><br> Time to get your own <br> singnature sign!`,
            price: 200000000,
            index: 8,
            isPurchaced: false,
            rate: 288,
            image_id: 7,
        },
        {
            id: "hat",
            name: "Snapback hat",
            description: `<b> Snapback hat </b><br> New part of your looks. <br> Favorite cap!`,
            price: 500000000,
            index: 9,
            isPurchaced: false,
            rate: 864,
            image_id: 8,
        },
        {
            id: "jacket",
            name: "Moncler jacket",
            description: `<b> Moncler jacket </b><br> Bring your bling to the max<br> Now all attention is yours!`,
            price: 1000000000,
            index: 10,
            isPurchaced: false,
            rate: 2592,
            image_id: 9,
        },
        {
            id: "tv",
            name: "Steal TV",
            description: `<b> Steal TV </b><br> Just a cozy jacket <br> for shoplifting TV's!`,
            price: 10000000000,
            index: 11,
            isPurchaced: false,
            rate: 7776,
            image_id: 10,
        },
    ],
    clicker: {
        index: 1,
        rate: 1,
        image_id: 1,
    },
    upgrade: [
        {
            id: "up1",
            name: "Flow",
            description: `<b> Flow </b> <br> Raise your vocal skills. <br /> RAP like a GOD!`,
            count: 0,
            rate: 1,
            price: 100,
            money: 1,
            ratePrice: 1.5,
            autoClick: false,
            addSum: 0,
        },
        {
            id: "up2",
            name: "Boombox",
            description: `<b> Boombox </b><br> Get your first boombox <br> to earn your cash easier!`,
            rate: 1,
            count: 0,
            price: 150,
            money: 1,
            ratePrice: 1.2,
            autoClick: true,
        },
        {
            id: "up3",
            name: "Cheep Mic",
            description: `<b> Cheap Mic </b><br> Every rapper needs a mic <br> to be heard!`,
            rate: 1,
            count: 0,
            price: 774,
            money: 4,
            ratePrice: 1.2,
            autoClick: true,
        },
        {
            id: "up4",
            name: "Contract with label",
            description: `<b> Contract with Label </b><br> Sign a contract with a Label. <br> They will promote you even more!`,
            rate: 1,
            count: 0,
            price: 3994,
            money: 13,
            ratePrice: 1.2,
            autoClick: true,
        },
        {
            id: "up5",
            name: "Recording Studio",
            description: `<b> Recording Studio </b><br> Your very own recording. <br> Now everything is up to you!`,
            rate: 1,
            count: 0,
            price: 20608,
            money: 46,
            ratePrice: 1.2, //
            autoClick: true,
        },
        {
            id: "up6",
            name: "Shiny Wheels",
            description: `<b> Shiny Wheels </b><br> New set of wheels for bling <br> and to do even more in same time!`,
            rate: 1,
            count: 0,
            price: 106333,
            money: 165,
            ratePrice: 1.2, //
            autoClick: true,
        },
        {
            id: "up7",
            name: "Fan Chix",
            description: `<b> Fan Chix </b><br> Every rapper needs Fan Chix <br> to relax him and inspire!`,
            rate: 1,
            count: 0,
            price: 548655,
            money: 593,
            ratePrice: 1.2, //
            autoClick: true,
        },
        {
            id: "up8",
            name: "Hip-Hop Club",
            description: `<b> Hip-Hop Club </b><br> A shiny club for the stage, <br> crazy parties and to make some cash!`,
            rate: 1,
            count: 0,
            price: 2830939,
            money: 2123,
            ratePrice: 1.2, //
            autoClick: true,
        },
        {
            id: "up9",
            name: "Grammy Award",
            description: `<b> Grammy Award </b><br> Spice it up a bit and <br> get awarded with Grammy!`,
            rate: 1,
            count: 0,
            price: 14607023,
            money: 7609,
            ratePrice: 1.2, //
            autoClick: true,
        },
        {
            id: "up10",
            name: "Merch Store",
            description: `<b>Merch Store </b><br> Now that you are popular everyone  <br> wants your brand! <br> Don't loose it!`,
            rate: 1,
            count: 0,
            price: 75369030,
            money: 27263,
            ratePrice: 1.2, //
            autoClick: true,
        },
    ]
}